import { Button } from '@/components/ui/button';

export type ComposerMode = 'manual' | 'platform-specific';

interface ComposerModeToggleProps {
  mode: ComposerMode;
  onChange: (mode: ComposerMode) => void;
}

export function ComposerModeToggle({ mode, onChange }: ComposerModeToggleProps) {
  return (
    <div
      className="inline-flex rounded-lg border bg-muted p-1 gap-1"
      role="group"
      aria-label="Posting mode"
    >
      <Button
        variant={mode === 'manual' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onChange('manual')}
        aria-pressed={mode === 'manual'}
      >
        Manual
      </Button>
      <Button
        variant={mode === 'platform-specific' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onChange('platform-specific')}
        aria-pressed={mode === 'platform-specific'}
      >
        Platform Specific
      </Button>
    </div>
  );
}
